import React, { useEffect, useState } from "react";
import Tooltip from '@mui/material/Tooltip';

// OperatorUserAvatar: Componente que renderiza el ávatar con las iniciales del operador.
// En caso de tratarse de un ávatar en el Inbox, devuelve con el color de la prioridad del chat.

const OperatorUserAvatar = ({ iniciales, priorityByTime }) => {

    const [operatorAssingned, setOperatorAssigned] = useState("n/a");

    useEffect(() => {
        if (iniciales) setOperatorAssigned(iniciales);
        else setOperatorAssigned("n/a");
    }, [iniciales, priorityByTime]);

    return (
        <Tooltip title="Operador asignado" >
            <div className={`user-profile__chat ${priorityByTime}`}>
                <div className="user-profile__chat-text">
                    <span>{operatorAssingned}</span>
                </div>
            </div>
        </Tooltip>
    )
};

export default OperatorUserAvatar;